// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"ProviderSocialLinks_socialIcon__PsGT5","websiteContainer":"ProviderSocialLinks_websiteContainer__Yw8O2"};